import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import translate from "../../../i18n/translate";
// Icons
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PendingIcon from "@mui/icons-material/Pending";
import SettingsIcon from "@mui/icons-material/Settings";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import Pagination from "@mui/material/Pagination";
import moment from "moment";
import ShareIcon from "@mui/icons-material/Share";
import { dataLanguage } from "../../../i18n/translateRequest";
import TextFieldGroup from "../../../components/common/TextFieldGroup";
import { EMPTY_CREDIT } from "../../../components/companies/jawwal/credits";
import RotatingIcon from "components/common/RotatePendingIcon";
import UploadIcon from "@mui/icons-material/Upload";
import DownloadIcon from "@mui/icons-material/Download";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import { chargeJawwal, chargeOoredoo } from "../../../actions/companiesAction";

import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  TablePagination,
  Typography,
  Tooltip,
  Checkbox,
} from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import CancelTransactionModal from "../../../components/common/CancelTransactionModal";

// import refund from "assests/images/icons/cancel.png";
import { useHistory } from "react-router-dom";
import { Grid } from "@mui/material";
import SaleReportTableStyles from "./SaleReportTableStyles.js";
import { makeStyles } from "@mui/styles";
import {
  CARD_TYPES,
  CARD_TYPES_FROM_API,
  PROVIDERS,
} from "../../../shared/constants/constants";
import CopyButton from "../CopyButton/CopyButton";
import { isEnglish } from "../../../shared/utils/languageUtils";
import {
  conditionalReturn,
  isNullOrUndefined,
  isPast24Hours,
  isPast48Hours,
  parseBool,
} from "shared/utils/utils";
import { isPeletalk } from "shared/utils/ppUtils";
import HTable from "material-htable2";
import { HCard, HCardHeader } from "material-hcard-private";
import RefreshButton from "../RefreashButton/RefreshButton";
import Modal from "../../../components/common/Modal";
import ApiRequest from "../../../actions/ApiRequest";
import Notiflix, { Loading } from "notiflix";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FormatSizeIcon from "@mui/icons-material/FormatSize";
import AssessmentIcon from "@mui/icons-material/Assessment";
import TableRowsIcon from "@mui/icons-material/TableRows";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import UndoOutlinedIcon from "@mui/icons-material/UndoOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";
import BarChartIcon from "@mui/icons-material/BarChart";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Popover from "@mui/material/Popover";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ExportButton from "components/common/ExportButton";
import Sage50ExportButton from "../Sage50ExportButton/Sage50ExportButton";
import StatisticsModal from "components/report/StatisticsModal";
import { useEffect } from "react";
import SelectSeller from "../../../components/cards/SelectSeller";
import ImageModal from "components/cards/UploadImage";
import ShareModal from "components/profile/ShareModal";
import { useIsAdmin } from "shared/hooks/ppHooks";
import UploadImage from "components/esim/UploadImage";
import Toast from "components/common/Toast";
import { intl } from "i18n/provider";
import { set } from "lodash";
import ContactSellerModal from "components/modals/ContactSellerModal/ContactSellerModal";
import PrintButton from "../printButton/PrintButton";
import { ShowToastPromise } from "components/common/ShowToastPromise";
const propTypes = {
  title: PropTypes.oneOfType(
    PropTypes.object,
    PropTypes.string,
    PropTypes.node
  ),
  isLoading: PropTypes.bool,
  isCreditReport: PropTypes.bool,
  hideTotals: PropTypes.bool,
  totalText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleOffsetValue: PropTypes.func,
  handleSortChange: PropTypes.func,
  sort: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onEditClick: PropTypes.func,
};

const useStyle = makeStyles(SaleReportTableStyles);

function SaleReportTable(props) {
  const {
    title,
    count,
    onRefresh,
    onSearch,
    onReset,
    page,
    handleOffsetValue,
    handleSortChange,
    sort,
    onEditClick,
    isCreditReport,
    onRowsPerPageChange,
    onPageChange,
    rowsPerPage,
    totalText,
    onSettingClick,
    isLoading,
    onLoadingSetting,
    chargeOoredoo,
    chargeJawwal,
    showBillerTotals,
    onToggleBillerTotals,
    // Header toggle controls
    cancelRequest,
    onToggleCancelRequest,
    canceled,
    onToggleCanceled,
    renew,
    onToggleRenew,
    autoRun,
    onToggleAutoRun,
    isAdminSeller,
    isAdminSearching,
  } = props;
  const classes = useStyle(props);
  const [image, setImage] = useState(null);
  const [imageModal, setImageModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [isUploadImageLoading, setIsUploadImageLoading] = useState(false);
  const [showRowsDropdown, setShowRowsDropdown] = useState(false);
  const [showStatisticsModal, setShowStatisticsModal] = useState(false);
  const [statisticsData, setStatisticsData] = useState([]);
  const [loadingStatistics, setLoadingStatistics] = useState(false);
  const hide = localStorage.getItem("hide companies") === "true";

  const sellerReports = useSelector((state) => state.reports.sellerReports);
  const isDarkTheme = useSelector((state) => state.darkTheme.isDarktheme);

  // isAdminSeller is provided via props from Report.js

  const isOtherSeller = useSelector(
    (state) => state.auth?.user.seller_type?.toLowerCase() === "other"
  );
  const [isUpdateFieldLoading, setIsUpdateFieldLoading] = useState(false);
  const [editField, setEditField] = React.useState({
    fieldName: "",
    value: "",
  });
  const [tranId, setTranId] = React.useState("");
  const [isFieldModalOpened, setIsFieldModalOpened] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [get_allsellers, setGet_allsellers] = React.useState([]);
  const [amountSeller, setAmountSeller] = React.useState("");
  const [openImageModal, setOpenImageModal] = React.useState(false);
  const [WhatsAppNote, setWhatsAppNote] = React.useState("");
  const [openShareModal, setOpenShareModal] = React.useState(false);
  const [referalCode, setReferalCode] = React.useState("");
  const [shareContent, setShareContent] = React.useState("");
  const sellerId = useSelector((state) => state.auth?.user);
  const { isReseller } = useIsAdmin();

  // Contact seller modal state
  const [contactModalOpen, setContactModalOpen] = React.useState(false);
  const [contactSeller, setContactSeller] = React.useState({ sellerId: "", sellerName: "" });

  // Font size state - small, medium, large
  const [reportFontSize, setReportFontSize] = React.useState(() => {
    return localStorage.getItem("reportFontSize") || "medium";
  });

  const getFontSizes = (size) => {
    const sizes = {
      // Make header font equal to base for compact, consistent look
      small: { base: "0.68rem", header: "0.68rem", trans: "0.7rem", seller: "0.68rem", icon: "1.4rem", logo: 35 },
      medium: { base: "0.85rem", header: "0.85rem", trans: "0.875rem", seller: "0.85rem", icon: "1.8rem", logo: 45 },
      large: { base: "1rem", header: "1rem", trans: "1rem", seller: "1rem", icon: "2.2rem", logo: 55 },
    };
    return sizes[size] || sizes.medium;
  };

  const toggleFontSize = () => {
    const sizes = ["small", "medium", "large"];
    const currentIndex = sizes.indexOf(reportFontSize);
    const nextSize = sizes[(currentIndex + 1) % sizes.length];
    setReportFontSize(nextSize);
    localStorage.setItem("reportFontSize", nextSize);
  };

  const currentFontSizes = getFontSizes(reportFontSize);

  useEffect(() => {
    const getAllSellers = async () => {
      const res = await ApiRequest.post(
        `get_allseller?reseller_id=${isReseller ? sellerId.id : ""}`
      );
      setGet_allsellers(res.data.all_sellers);
    };

    getAllSellers();
  }, []);

  const sendImage = async () => {
    if (!image) return;
    setIsUploadImageLoading(true);
    try {
      const formData = new FormData();
      formData.append("image", image, `img.jpg`);
      await ApiRequest.post(
        `upload_bill_receipt?trans_id=${selectedReport.transid}`,
        formData
      );
      setIsUploadImageLoading(false);
      setImageModal(false);
      setImage(null);
      Toast.fire({
        title: intl.formatMessage({
          id: "Your Message has been sent successfully",
        }),
        icon: "success",
      });
    } catch (error) {
      setIsUploadImageLoading(false);
      Toast.fire({
        title: intl.formatMessage({
          id: "Something Went Wrong",
        }),
        icon: "error",
      });
      Notiflix.Report.failure("Something Went Wrong", "", "Close");
    }
  };
  const history = useHistory();
  const onDownloadBillClick = (report) => {
    const url = report?.url;

    if (url) {
      window.open(url, "_blank");
    }
  };

  const cardAmountHandle = (item) => {
    const isJawwalOrOoredoo = ["Jawwal", "Ooredoo"].includes(item.provider);
    const normalizedTransType = item?.transtype
      ?.toString?.()
      ?.toLowerCase?.()
      ?.replace(/\s|_/g, "");
    const isTopup = normalizedTransType === "topup";

    // Use same size for all languages - CSS will handle the override
    const fontSize = "48px"; // 37px + 30% = 48.1px (rounded to 48px)

    // Only use the credit overlay when there's NO specific bundle image URL
    // i.e., for real top-up credit transactions where backend sends url as 'N/A'
    if (isJawwalOrOoredoo && isTopup && (item.url === "N/A" || !item.url)) {
      return (
        <div className="report-image-wrapper" style={{ position: "relative", width: "210px", height: "100px", margin: "auto" }}>
          <img alt="" src={EMPTY_CREDIT.url} className="report-image" style={{ width: "210px", height: "100px", display: "block" }} />
          <div
            className="card-amount-overlay"
            style={{
              position: "absolute",
              top: "50%",
              left: "56%",
              transform: "translateY(-50%)",
              fontSize: fontSize,
              fontFamily: "Dubai, Montserrat, sans-serif",
              color: "#047857",
              fontWeight: "700",
              lineHeight: "1",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "38%",
              height: "48%"
            }}
          >
            {item.cardamount}
          </div>
        </div>
      );
    } else {
      let imgSrc = "";
      try {
        imgSrc =
          item.url === "N/A"
            ? require(`../../../assests/images/bundles/${item.provider.toLowerCase()}/${item.provider.toLowerCase()}-${item.cardamount
              ?.toString()
              ?.replace("-", "")}.png`).default
            : item.url;
      } catch (error) {
        console.log("cardAmountHandle SaleReportTable", error);
      }
      // return (
      //   <span style={{ display: "inline-block", width: 120, height: 57, paddingRight: 4 }}>
      //     <AmountCard amount={item.cardamount?.toString()?.replace("-", "")} />
      //   </span>
      // );
      return (
        <img
          alt={item.cardamount?.toString()}
          src={imgSrc}
          className="report-image"
        />
      );
    }
  };

  const handleTelecomRouting = (provider, number) => {
    switch (provider) {
      case "Jawwal":
        history.push(`/company/jawwalCredit/${number}`, {
          provider_id: "001",
        });
        break;
      case "Ooredoo":
        history.push(`/company/ooredoo/credit/${number}`, {
          provider_id: "002",
        });
        break;
      case "Paltel":
        history.push(`/pay_bills/paltel`, {
          number: number,
        });
        break;
      case "Hot":
        history.push(
          `/company/hot/${number}?providerId=008&mobileNumber=${number}`,
          {
            provider_Id: "008",
            mobileNumber: number,
          }
        );
        break;
      case "Mobile019":
        history.push(
          `/company/azy/${number}?providerId=009&mobileNumber=${number}`,
          {
            provider_Id: "009",
            mobileNumber: number,
          }
        );
        break;
      case "Cellcom 2":
        history.push(
          `/company/group/Cellcom 2/${number}?providerId=218&mobileNumber=${number}`,
          {
            provider_Id: "218",
            mobileNumber: number,
          }
        );
        break;
      case "Pelephone":
        history.push(
          `/company/group/Pelephone/${number}?providerId=095&mobileNumber=${number}`,
          {
            provider_Id: "095",
            mobileNumber: number,
          }
        );
        break;
      case "Partner":
        history.push(
          `/company/group/Partner/${number}?providerId=127&mobileNumber=${number}`,
          {
            provider_Id: "127",
            mobileNumber: number,
          }
        );
        break;
      case "012 Mobile":
        history.push(
          `/company/group/012 mobile/${number}?providerId=201&mobileNumber=${number}`,
          {
            provider_Id: "201",
            mobileNumber: number,
          }
        );
        break;
      case "Golan Telecom":
        history.push(
          `/company/group/Golan telecom/${number}?providerId=214&mobileNumber=${number}`,
          {
            provider_Id: "214",
            mobileNumber: number,
          }
        );
        break;
      case "Nedco":
        history.push(`/pay_bills/nedco`, {
          number: number,
        });
        break;
      case "Selco":
        history.push(`/pay_bills/selco`, {
          number: number,
        });
        break;
      case "Mada":
        history.push(`/pay_bills/mada`, {
          number: number,
        });
        break;
      case "Gemzo":
        history.push(`/pay_bills/gemzo`, {
          number: number,
        });
        break;
      case "Jawwal Invoice":
        history.push(`/pay_bills/jawwal`, {
          number: number,
        });
        break;
      case "Ooredoo Invoice":
        history.push(`/pay_bills/ooredoo_bills`, {
          number: number,
        });
        break;

      case "Pubg":
        history.push(`/gaming/004`, {
          number: number,
        });
        break;
      case "Jawaker":
        history.push("/jwaker", {
          number: number,
        });
        break;
      case "Tiktok":
        history.push("/tiktok", {
          number: number,
        });
        break;
      default:
        break;
    }
  };

  // Repost a failed transaction: for Jawwal/Ooredoo re-run the exact same
  // charge in place; for everything else route back to the provider's buy
  // page pre-filled with the same mobile number.
  const handleRepost = (report) => {
    if (report.provider === "Jawwal" || report.provider === "Ooredoo") {
      resendFailedTransaction(report);
    } else {
      handleTelecomRouting(report.provider, report.number);
    }
  };

  // Build a human-readable summary of a transaction to share over WhatsApp.
  const buildTransactionMessage = (report) => {
    const t = (id) => intl.formatMessage({ id });
    const lines = [
      `*${t("Transaction Details")}*`,
      `${t("serial.no")}: ${report.transid}`,
      `${t("date")}: ${moment(report.datetime).format("YYYY-MM-DD - HH:mm")}`,
      `${t("Provider")}: ${report.provider}`,
      `${t("Mobile No.")}: ${report.number}`,
      `${t("Trans. Type")}: ${report.transtype} / ${report.card_type}`,
      `${t("value")}: ${report.cardamount || 0}`,
      `${t("Status")}: ${report.status}`,
    ];
    if (
      !isNullOrUndefined(report.reference_no) &&
      report.reference_no?.toString().toUpperCase() !== "N/A"
    ) {
      lines.push(`Reference Number: ${report.reference_no}`);
    }
    return lines.join("\n");
  };

  // Open the share modal pre-loaded with the transaction details so the user
  // can enter a WhatsApp number and send them.
  const handleShareTransaction = (report) => {
    setReferalCode("");
    setShareContent(buildTransactionMessage(report));
    setOpenShareModal(true);
  };

  const chargeJawwalExtra = async (updateReport, cardType) => {
    const g3 = cardType == CARD_TYPES_FROM_API.jawwal3g ? updateReport : null;
    const rom = cardType == CARD_TYPES_FROM_API.jawwalRom ? updateReport : null;
    const credit =
      cardType == CARD_TYPES_FROM_API.jawwalCredit ? updateReport : null;
    const min = cardType == CARD_TYPES_FROM_API.jawwalMin ? updateReport : null;
    const plus =
      cardType == CARD_TYPES_FROM_API.jawwalPlus ? updateReport : null;
    return await chargeJawwal(
      {
        jawwal3g: g3,
        jawwalRom: rom,
        jawwalCredit: credit,
        jawwalMin: min,
        jawwalPlus: plus,
      },
      undefined,
      undefined,
      false,
      updateReport.number,
      true
    );
  };

  const chargeOoredooExtra = async (updateReport, cardType) => {
    const min =
      cardType == CARD_TYPES_FROM_API.ooredooMin ? updateReport : null;
    const rom =
      cardType == CARD_TYPES_FROM_API.ooredooRom ? updateReport : null;
    const shabab =
      cardType == CARD_TYPES_FROM_API.ooredooShabab ? updateReport : null;
    const g3 = cardType == CARD_TYPES_FROM_API.ooredoo3g ? updateReport : null;
    const credit =
      cardType == CARD_TYPES_FROM_API.ooredooCredit ? updateReport : null;

    console.log("updateReport", updateReport, rom, credit, min, g3, shabab);

    return await chargeOoredoo(
      {
        ooredoo3g: g3,
        ooredooRom: rom,
        ooredooCredit: credit,
        ooredooMin: min,
        ooredooSuper: shabab,
      },
      undefined,
      undefined,
      false,
      updateReport.number,
      true
    );
  };

  const resendFailedTransaction = async (report) => {
    const provider = report.provider;
    const cardType = report.card_type?.toLowerCase();
    const updateReport = {
      price: report.cardamount,
      pci: report.PCI,
      id: cardType === "credit" ? "0" : report.PCI,
      bundleid: report.PCI,
      cardType: report.card_type,
      url: report.url,
      number: report.number,
    };
    if (provider === "Jawwal") {
      ShowToastPromise(chargeJawwalExtra.bind(null, updateReport, cardType), {
        mobileNumber: report.number,
      });
    } else if (provider === "Ooredoo") {
      ShowToastPromise(chargeOoredooExtra.bind(null, updateReport, cardType), {
        mobileNumber: report.number,
      });
    }
  };

  const showCancellation = (report) => {
    const cardType = report?.card_type;
    const provider = report?.provider;
    const transtype = report?.transtype;
    if (
      parseBool(report.cancelrequest) ||
      parseBool(report.canceled) ||
      report.status !== "success" ||
      !isNaN(Number(provider)) ||
      ["GAME", "voucher", "ADD CREDITS"].includes(cardType) ||
      (cardType === "Credit" && provider !== "Jawwal" && provider !== "Ooredoo") ||
      transtype === "Add Credits" ||
      [
        "Jawaker",
        "Pubg",
        "Ooredoo Invoice",
        "Nedco",
        "Selco",
        "Jawwal Invoice",
        "Mada",
        "Tiktok",
        "Sms",
        "Paltel",
      ].includes(provider) ||
      (provider === "Jawwal" && cardType !== "Credit")
    ) {
      return false;
    }

    let show = false;

    const reportDate = new Date(report?.datetime);
    const past24Hours = isPast24Hours(reportDate);
    const past48Hours = isPast48Hours(reportDate);

    if (!past24Hours) {
      show = true;
    }

    if (!past48Hours && provider === PROVIDERS.ooredoo) {
      show = true;
    }

    if (!past24Hours && provider === PROVIDERS.hot) {
      show = true;
    }

    if (isPeletalk(provider) && !past48Hours) {
      show = true;
    }

    return show;
  };

  const handleEditField = (value, fieldName, tranId) => {
    setEditField({
      fieldName,
      value,
    });
    setTranId(tranId);
    setIsFieldModalOpened(true);
  };

  const handleWhatsApp = (note, transId, number) => {
    const phoneNumberPattern = /^\d+$/;
    if (phoneNumberPattern.test(note)) {
      // Note is a valid number
      // const urlOrPhoneNumber = `http://wa.me/${note}`;
      // window.open(urlOrPhoneNumber, "_blank");
      setWhatsAppNote({ note, transId, number });
      setOpenImageModal(true);
    } else {
      Notiflix.Notify.failure("Invalid Phone Number");
    }
  };
  function enforceLTR(str) {
    return `\u202A${str}\u202C`;
  }
  // Nedco meter numbers are long \u2014 split them in groups of 3 for readability.
  const formatMeterNumber = (number) => {
    const str = number?.toString() || "";
    return str.replace(/(\d{3})(?=\d)/g, "$1-");
  };

  const handleCloseEditField = () => {
    setEditField({
      fieldName: "",
      value: "",
    });
    setTranId("");
    setIsUpdateFieldLoading(false);
    setIsFieldModalOpened(false);
  };

  const handleNoteChange = (event) => {
    setEditField({ ...editField, value: event.target.value });
  };

  const updateTransactionField = async () => {
    handleCloseEditField();
    setIsUpdateFieldLoading(true);
    let fieldName = "note";

    if (editField.fieldName === "Reference Number") {
      fieldName = "ref";
    } else if (editField.fieldName === "Top Up Account") {
      fieldName = "topup_account";
    }
    try {
      const { data } = await ApiRequest.post(
        `update_field?trans_id=${tranId}&new_value=${editField.value}&req_field=${fieldName}`
      );
      if (data.status === "failed") {
        throw new Error(data["reason:"]);
      }
      handleCloseEditField();
      onRefresh();
    } catch (error) {
      Notiflix.Notify.failure("Something went Wrong - " + error?.message);
    } finally {
      setIsUpdateFieldLoading(false);
    }
  };

  function renderHTable() {
    const heads = [
      translate("serial.no"),
      translate("provider"),
      !isOtherSeller && {
        component: <h6>{translate("seller")}</h6>,
        props: {
          sx: { width: 150, textAlign: "center" },
        },
      },
      !isOtherSeller && translate("seller_id"),
      isCreditReport && {
        component: <h6>{translate("reseller_id")}</h6>,
        props: {
          sx: { width: 120, textAlign: "center" },
        },
      },
      isCreditReport && {
        component: <h6>{translate("subprovider")}</h6>,
        props: {
          sx: { width: 120, textAlign: "center" },
        },
      },
      translate("Trans. Type"),
      !isCreditReport && translate("Mobile No."),
      translate("Card Type"),
      translate("date"),
      translate("dealer_cost"),
      translate("value"),
      translate("Status"),
    ]
      .filter(Boolean)
      .map((h, i) =>
        h.component
          ? {
            ...h,
            props: Object.assign(
              {
                style: {
                  width: 100,
                  padding: 0,
                },
              },
              h.props
            ),
          }
          : {
            id: new Date().getTime(),
            component: <h6>{h}</h6>,
            props: {
              style: {
                width: 100,
                padding: 0,
              },
            },
          }
      );

    const rows = sellerReports.map((report, index) => {
      const isSuccessfulReport = report.status === "success";
      const isFailedReport = report.status === "failed";
      const StatusIcon = isSuccessfulReport
        ? CheckCircleIcon
        : isFailedReport
          ? CancelIcon
          : RotatingIcon;
      const isManualCorrection = report?.["manual correction"] === "true";

      const cells = [
        {
          component: (
            <Box>
              <Typography
                id="sales-trans-id"
                sx={{
                  fontWeight: "bold",
                  fontSize: currentFontSizes.trans,
                  ...(+report.newsellerbalance < 0 && { color: "red" }),
                }}
              >
                {report.transid}
              </Typography>
              <Grid item md={12} container justifyContent={"center"}>
                <CopyButton
                  buttonClassName={classes.hCopyButton}
                  textToCopy={report?.transid?.toString()}
                  iconClassName={classes.copyIcon}
                />
              </Grid>
            </Box>
          ),
          props: { style: { paddingLeft: "12px" } },
        },
        {
          props: { style: { textAlign: "center" } },
          component: (
            <Box
              sx={{
                width: "100px",
              }}
            >
              <img
                style={{
                  maxHeight: 45,
                  maxWidth: 45,
                  width: 45,
                  height: 45,
                  margin: 0,
                  display: "inline-block",
                  objectFit: "contain",
                }}
                src={report.provider_logo_url}
                alt="provider logo"
              />
            </Box>
          ),
        },
        !isOtherSeller && {
          component: (
            <Box>
              <Grid container alignItems="center" justifyContent="center">
                <Typography
                  className={classes.sellerNameP}
                  onClick={() => history.push(`/add_credits?seller_id=${report.seller_id}`)}
                  sx={{
                    direction: isEnglish(report.name) ? "ltr" : "rtl",
                    fontSize: currentFontSizes.seller,
                    cursor: "pointer",
                    color: +report.newsellerbalance < 0 ? "red" : "#1976d2",
                    textDecoration: "underline",
                    "&:hover": {
                      color: +report.newsellerbalance < 0 ? "#ff6666" : "#1565c0",
                    },
                  }}
                  title="Click to add credits for this seller"
                >
                  {report.name}
                </Typography>
                {isAdminSeller && (
                  <Tooltip title="Contact Seller">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setContactSeller({ sellerId: report.seller_id, sellerName: report.name });
                        setContactModalOpen(true);
                      }}
                      sx={{ ml: 0.5, color: "#25D366" }}
                    >
                      <ContactPhoneIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>
            </Box>
          ),
          props: {
            title: report.name,
            sx: {
              padding: 0,
              minWidth: 100,
              maxWidth: 180,
              textAlign: "center",
              "& *": { display: "inline-block" },
            },
          },
        },
        !isOtherSeller && (
          <Box>
            <Typography
              id="sales-seller-id"
              onClick={() => history.push(`/add_credits?seller_id=${report.seller_id}`)}
              sx={{
                fontWeight: "bold",
                fontSize: currentFontSizes.seller,
                cursor: "pointer",
                color: +report.newsellerbalance < 0 ? "red" : "#1976d2",
                textDecoration: "underline",
                "&:hover": {
                  color: +report.newsellerbalance < 0 ? "#ff6666" : "#1565c0",
                },
              }}
              title="Click to add credits for this seller"
            >
              {report.seller_id}
            </Typography>
            <Grid item md={12} container justifyContent={"center"}>
              <CopyButton
                buttonClassName={classes.hCopyButton}
                textToCopy={report?.seller_id?.toString()}
                iconClassName={classes.copyIcon}
              />
            </Grid>
          </Box>
        ),
        isCreditReport && (
          <Box>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: currentFontSizes.base,
                ...(+report.newsellerbalance < 0 && { color: "red" }),
              }}
            >
              {report.reseller_id || "N/A"}
            </Typography>
            <Grid item md={12} container justifyContent={"center"}>
              <CopyButton
                buttonClassName={classes.hCopyButton}
                textToCopy={report?.reseller_id?.toString()}
                iconClassName={classes.copyIcon}
              />
            </Grid>
          </Box>
        ),
        isCreditReport && (
          <Typography
            sx={{
              width: "80px",
              fontSize: currentFontSizes.base,
              textTransform: "uppercase",
              ...(+report.newsellerbalance < 0 && { color: "red" }),
            }}
            title={report.subprovider || "N/A"}
          >
            {report.subprovider || "N/A"}
          </Typography>
        ),
        <Typography sx={{ width: "60px", fontSize: currentFontSizes.base }}>{translate(report.transtype)}</Typography>,
        !isCreditReport && {
          props: {
            style: {
              color: "black",
              position: "relative",
              cursor: "pointer",
            },
            onClick: () => handleTelecomRouting(report.provider, report.number),
          },
          component: (
            <Grid container sx={{ width: "70px" }}>
              <Grid item md={12} container justifyContent={"center"}>
                <p
                  id="sales-table-number"
                  style={{
                    padding: 0,
                    margin: 0,
                    fontSize: currentFontSizes.base,
                    ...(+report.newsellerbalance < 0 && { color: "red" }),
                    whiteSpace: "nowrap",
                  }}
                >
                  {report.provider === "Nedco"
                    ? enforceLTR(formatMeterNumber(report.number))
                    : report.number}
                </p>
              </Grid>
              <Grid item md={12} container justifyContent={"center"}>
                <CopyButton
                  buttonClassName={classes.hCopyButton}
                  textToCopy={report?.number?.toString()}
                  iconClassName={classes.copyIcon}
                />
                <CopyButton
                  buttonClassName={classes.hCopyButton}
                  textToCopy={report?.number?.toString().substring(2)}
                  iconClassName={classes.copyIcon}
                  copyType={true}
                />
              </Grid>
            </Grid>
          ),
        },
        <Typography
          sx={{
            fontSize: currentFontSizes.base,
            ...(+report.newsellerbalance < 0 && { color: "red" })
          }}
        >
          {translate(report.card_type)}
        </Typography>,
        <Box sx={{ mr: 2 }}>
          <Typography
            sx={{
              fontSize: currentFontSizes.base,
              ...(+report.newsellerbalance < 0 && { color: "red" })
            }}
          >
            {moment(report.datetime).format("LT")}
          </Typography>
          <Typography
            sx={{
              fontSize: currentFontSizes.base,
              ...(+report.newsellerbalance < 0 && { color: "red" })
            }}
          >
            {moment(report.datetime).format("YYYY/MM/DD")}
          </Typography>
        </Box>,
        <Typography
          sx={{
            width: "60px",
            fontSize: currentFontSizes.base,
            ...(+report.newsellerbalance < 0 && { color: "red" }),
          }}
        >
          {report.dealercost || 0}
        </Typography>,
        <Typography
          sx={{
            width: "60px",
            fontSize: currentFontSizes.base,
            ...(+report.newsellerbalance < 0 && { color: "red" }),
          }}
        >
          {report.cardamount || 0}
        </Typography>,

        <>
          <StatusIcon
            color={
              isSuccessfulReport ? "success" : isFailedReport ? "error" : ""
            }
            time={report.datetime}
            sx={{
              fontSize: currentFontSizes.icon,
              marginLeft: "0.5rem",
            }}
          />
          {conditionalReturn(
            report?.status === "success" && parseBool(report?.cancelrequest),
            <span className={classes.canceledRequestUnderLine} />
          )}
        </>,
        <>
          {conditionalReturn(
            report.cancelrequest &&
            report.cancelrequest?.toLowerCase() !== "false" &&
            report.card_type !== "ADD CREDITS" &&
            report.card_type !== "Credit" &&
            report.transtype !== "Add Credits",
            <CancelTransactionModal
              canceled={report.canceled?.toLowerCase() !== "false"}
              notClickable={true}
            />
          )}
        </>,
      ];

      const isNotSuccessfulTrans = report.status !== "success";
      const isSuccessfulTrans = report.status === "success";
      const isFailedTrans = report.status === "failed";

      const showCancelRequist =
        parseBool(report?.cancelrequest) && !parseBool(report?.canceled);

      const collapse = (
        <Grid
          container
          key={index}
          justifyContent="space-between"
          flexWrap={"nowrap"}
          minHeight="100px"
          paddingTop={"6px"}
          paddingBottom={"6px"}
          paddingLeft="12px"
          paddingRight={"8px"}
          sx={{
            fontSize: currentFontSizes.base,
            "& *": {
              fontSize: "inherit",
            },
          }}
        >
          <Grid item xs={5} md={5}>
            <Grid item container className={classes.collapseItemContainer}>
              <Grid item>
                <Typography className="list-label" fontWeight={"bold"}>
                  {translate("Renewable")}:
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  className={classes.collapseItemValue}
                  fontWeight={"bolder"}
                  color="blue"
                >
                  {report.autorenew ? translate("Yes") : translate("No")}
                </Typography>
              </Grid>
            </Grid>
            <Grid item container className={classes.collapseItemContainer}>
              <Grid item>
                <Typography className="list-label" fontWeight={"bold"}>
                  {translate("trans type")}:
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={classes.collapseItemValue}>
                  {translate(report.card_type)}
                </Typography>
              </Grid>
            </Grid>
            {conditionalReturn(
              isNotSuccessfulTrans,
              <Grid item container className={classes.collapseItemContainer}>
                <Grid item>
                  <Typography className="list-label" fontWeight={"bold"}>
                    {translate("Reason")}:
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.collapseItemValue}>
                    {translate(report.reason)}
                  </Typography>
                </Grid>
              </Grid>
            )}
            <Grid item container className={classes.collapseItemContainer}>
              <Grid item>
                <Typography className="list-label" fontWeight={"bold"}>
                  {translate("description")}:
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={classes.collapseItemValue}>
                  {(() => {
                    const description = dataLanguage(report, "ar_des", "en_des", "he_des");

                    // Check for card/bundle ID in different possible field names
                    const cardId = report.PCI || report.pci || report.bundleid || report.bundle_id || report.cardid || report.card_id;

                    // Bill providers should NOT show bundle codes (they show invoice numbers in bills table instead)
                    const billProviders = ['Jawwal Invoice', 'Ooredoo Invoice', 'Paltel', 'Mada', 'Nedco', 'Selco', 'Coolnet'];
                    const isBillProvider = billProviders.some(provider =>
                      report.provider?.toLowerCase().includes(provider.toLowerCase())
                    );

                    // Show bundle/card code ONLY for prepaid providers (not bills)
                    // Israeli providers, Jawwal bundles, Ooredoo bundles, etc.
                    if (cardId && cardId !== "0" && cardId !== 0 && !isBillProvider) {
                      return `${description} [${cardId}]`;
                    }
                    return description;
                  })()}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              item
              container
              className={classes.collapseItemContainer}
              sx={{ alignItems: "center" }}
            >
              <Grid item>
                <Typography className="list-label" fontWeight={"bold"}>
                  Reference Number
                </Typography>
              </Grid>
              <PrintButton content={report?.reference_no} />
              <CopyButton
                textToCopy={report?.reference_no?.toString()}
                iconClassName={classes.copyIcon}
                buttonClassName={classes.hCopyButton}
              />
              {isAdminSeller && (
                <Box>
                  <EditIcon
                    onClick={() => {
                      handleEditField(
                        report.reference_no,
                        "Reference Number",
                        report.transid
                      );
                    }}
                    sx={{
                      margin: 0,
                      marginLeft: "8px",
                      cursor: "pointer",
                    }}
                    color="info"
                  />
                </Box>
              )}
              {report.provider === "Nedco" && (
                <IconButton
                  size="small"
                  onClick={() => {
                    setShareContent("");
                    setReferalCode(report?.reference_no);
                    setOpenShareModal(true);
                  }}
                  sx={{
                    padding: "4px !important",
                    width: "28px !important",
                    height: "28px !important",
                    minWidth: "28px !important",
                    minHeight: "28px !important",
                    "& svg": {
                      fontSize: "17px !important",
                      width: "20px !important",
                      height: "20px !important"
                    }
                  }}
                >
                  <ShareIcon />
                </IconButton>
              )}
              :
              <Grid item>
                <Typography className={classes.referenceNoText}>
                  {enforceLTR(report?.reference_no)}
                </Typography>
              </Grid>
            </Grid>
            <Grid item container className={classes.collapseItemContainer}>
              <Grid>
                <Typography fontWeight={"bold"}>
                  {translate("Provider")}:
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={classes.collapseItemValue}>
                  {" "}
                  {report?.provider}
                </Typography>
              </Grid>
            </Grid>
            {/* {conditionalReturn(
              isAdminSeller && report?.seller_id,
              <Grid item container className={classes.collapseItemContainer}>
                <Grid item>
                  <Typography className="list-label" fontWeight={"bold"}>
                    {translate("Seller ID")}
                  </Typography>
                </Grid>
                <CopyButton
                  textToCopy={report?.seller_id?.toString()}
                  iconClassName={classes.copyIcon}
                  buttonClassName={classes.hCopyButton}
                />{" "}
                :
                <Grid item>
                  <Typography className={classes.collapseItemValue}>
                    {report?.seller_id}
                  </Typography>
                </Grid>
              </Grid>
            )} */}
            {conditionalReturn(
              !isNullOrUndefined(report?.topup_account) || isAdminSeller,
              <Grid item container className={classes.collapseItemContainer}>
                <Grid item>
                  <Typography className="list-label" fontWeight={"bold"}>
                    {translate("topUpAccount")}
                  </Typography>
                </Grid>
                <CopyButton
                  textToCopy={report?.topup_account?.toString()}
                  iconClassName={classes.copyIcon}
                  buttonClassName={classes.hCopyButton}
                />{" "}
                :
                <Grid item>
                  <Typography className={classes.collapseItemValue}>
                    {report?.topup_account}
                  </Typography>
                </Grid>
                {isAdminSeller && (
                  <Box>
                    <EditIcon
                      onClick={() => {
                        handleEditField(
                          report.topup_account,
                          "Top Up Account",
                          report.transid
                        );
                      }}
                      sx={{
                        margin: 0,
                        marginLeft: "8px",
                        cursor: "pointer",
                      }}
                      color="info"
                    />
                  </Box>
                )}
              </Grid>
            )}
          </Grid>
          <Grid item xs={5} md={4}>
            <Grid container>
              {conditionalReturn(
                !isNullOrUndefined(report?.cancelrequest),
                <Grid item container className={classes.collapseItemContainer}>
                  <Grid item>
                    <Typography className="list-label" fontWeight={"bold"}>
                      {translate("Cancel Request")}:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.collapseItemValue}>
                      {report?.cancelrequest?.toString()}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {conditionalReturn(
                !isNullOrUndefined(report?.canceled),
                <Grid item container className={classes.collapseItemContainer}>
                  <Grid item>
                    <Typography className="list-label" fontWeight={"bold"}>
                      {translate("Canceled")}:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      color={
                        isSuccessfulTrans
                          ? "green"
                          : isFailedTrans
                            ? "red"
                            : undefined
                      }
                      className={classes.collapseItemValue}
                    >
                      {report?.canceled?.toString()}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {conditionalReturn(
                !isNullOrUndefined(report?.["manual correction"]),
                <Grid item container className={classes.collapseItemContainer}>
                  <Grid item>
                    <Typography
                      className="list-label"
                      fontWeight={"bold"}
                      color={isManualCorrection ? "blue" : undefined}
                    >
                      {translate("Manual Correction")}:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      color={
                        isSuccessfulTrans
                          ? "green"
                          : isFailedTrans
                            ? "red"
                            : undefined
                      }
                      className={classes.collapseItemValue}
                    >
                      {report?.["manual correction"]}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {conditionalReturn(
                !isNullOrUndefined(report?.note) || isAdminSeller,
                <Grid item container className={classes.collapseItemContainer}>
                  <Grid item>
                    <Typography
                      className="list-label"
                      fontWeight={"bold"}
                      sx={{ marginRight: "8px" }}
                    >
                      {translate("Note")}:
                    </Typography>
                  </Grid>
                  <Grid item sx={{ display: "flex" }}>
                    <Typography
                      component="span"
                      className={classes.collapseItemValue}
                    >
                      {report?.note}
                    </Typography>
                    {isAdminSeller && (
                      <Box>
                        <EditIcon
                          onClick={() => {
                            handleEditField(
                              report.note,
                              "Note",
                              report.transid
                            );
                          }}
                          sx={{
                            margin: 0,
                            marginLeft: "8px",
                            cursor: "pointer",
                          }}
                          color="info"
                        />
                        <WhatsAppIcon
                          onClick={() => {
                            // console.log("report.note", report);
                            handleWhatsApp(
                              report.note,
                              report.transid,
                              report.number
                            );
                          }}
                          color={+report?.note ? "success" : "error"}
                          sx={{
                            margin: 0,
                            marginLeft: "4px",
                            cursor: "pointer",
                          }}
                        />
                      </Box>
                    )}
                  </Grid>
                </Grid>
              )}
              {conditionalReturn(
                !isNullOrUndefined(report?.returned_message),
                <Grid item container className={classes.collapseItemContainer}>
                  <Grid item>
                    <Typography className="list-label" fontWeight={"bold"}>
                      {translate("Returned Message")}:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.collapseItemValue}>
                      {report?.returned_message}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {conditionalReturn(
                !isNullOrUndefined(report?.PCI),
                <Grid item container className={classes.collapseItemContainer}>
                  <Grid item>
                    <Typography className="list-label" fontWeight={"bold"}>
                      {translate("PCI")}:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.collapseItemValue}>
                      {report?.PCI}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {conditionalReturn(
                !isNullOrUndefined(report?.dealercost),
                <Grid item container className={classes.collapseItemContainer}>
                  <Grid item>
                    <Typography className="list-label" fontWeight={"bold"}>
                      {translate("Dealer Cost")}:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.collapseItemValue}>
                      {report?.dealercost}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {conditionalReturn(
                !isNullOrUndefined(report?.newsellerbalance),
                <Grid item container className={classes.collapseItemContainer}>
                  <Grid item>
                    <Typography className="list-label" fontWeight={"bold"}>
                      {translate("New Seller Balance")}:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.collapseItemValue}>
                      {report?.newsellerbalance}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {conditionalReturn(
                !isNullOrUndefined(report?.profit),
                <Grid item container className={classes.collapseItemContainer}>
                  <Grid item>
                    <Typography className="list-label" fontWeight={"bold"}>
                      {translate("Profit")}:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.collapseItemValue}>
                      {report?.profit}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {conditionalReturn(
                isAdminSeller,
                <Grid item container className={classes.collapseItemContainer}>
                  <Grid item>
                    <Typography className="list-label" fontWeight={"bold"}>
                      {translate("Sub Provider")}:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.collapseItemValue}>
                      {report?.subprovider}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid
            item
            minWidth={"120px"}
            xs={report.card_type === "Bill" ? 5 : 3}
            md={report.card_type === "Bill" ? 5 : 3}
          >
            <Grid container spacing={0} direction="column">
              <Grid item md={12} xs={12} minHeight={"140px"}>
                {cardAmountHandle(report)}
              </Grid>
              <Grid
                item
                container
                md={12}
                xs={12}
                spacing={1}
                justifyContent={"center"}
                sx={{ mt: 0.5 }}
              >
                {conditionalReturn(
                  isFailedReport,
                  <Grid item>
                    <Tooltip title={intl.formatMessage({ id: "Repost Transaction" })}>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<ReplayIcon />}
                        onClick={() => handleRepost(report)}
                      >
                        {translate("Repost Transaction")}
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item>
                  <Tooltip title={intl.formatMessage({ id: "Send to WhatsApp" })}>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<WhatsAppIcon />}
                      onClick={() => handleShareTransaction(report)}
                      sx={{
                        backgroundColor: "#25D366",
                        "&:hover": { backgroundColor: "#1da851" },
                      }}
                    >
                      {translate("Send to WhatsApp")}
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid item md={12} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "8px",
                    paddingBottom: "4px",
                  }}
                >
                  {conditionalReturn(
                    isNotSuccessfulTrans &&
                    report?.provider === "Jawwal" &&
                    report?.provider !== "Ooredoo",
                    <IconButton
                      aria-label="resend"
                      color="info"
                      size="small"
                      onClick={() => resendFailedTransaction(report)}
                      sx={{
                        direction: "rtl",
                        margin: "0  4px ",
                        backgroundColor: "#ebebeb",
                        padding: "4px",
                        width: "28px",
                        height: "28px",
                        minWidth: "28px",
                        minHeight: "28px",
                        "& svg": { fontSize: "13.6px" }
                      }}
                    >
                      <CancelScheduleSendIcon />
                    </IconButton>
                  )}
                  {conditionalReturn(
                    showCancellation(report),

                    <CancelTransactionModal
                      tranId={report.transid}
                      isCNumber={report?.provider === "Jawwal"}
                      style={{
                        fontSize: "13.6px",
                        cursor: "pointer",
                        color: "#bd0303",
                      }}
                    />
                  )}

                  {conditionalReturn(
                    isAdminSeller,
                    <Box
                      sx={{
                        display: "flex",
                        // alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {report.card_type === "Bill" &&
                        conditionalReturn(
                          isAdminSeller,
                          <IconButton
                            aria-label="settings"
                            color="info"
                            size="small"
                            onClick={() => {
                              setAmountSeller(report);
                              setOpenModal(true);
                              //  onSettingClick(report);
                            }}
                            disabled={report?.status === "failed"}
                            sx={{
                              direction: "rtl",
                              margin: "0  4px ",
                              backgroundColor: "#ebebeb",
                              padding: "4px !important",
                              width: "28px !important",
                              height: "28px !important",
                              minWidth: "28px !important",
                              minHeight: "28px !important",
                              "& svg": {
                                fontSize: "17px !important",
                                width: "20px !important",
                                height: "20px !important"
                              }
                            }}
                          >
                            <SettingsIcon />
                          </IconButton>
                        )}
                      {report.card_type === "Bill" && (
                        <IconButton
                          aria-label="settings"
                          color="info"
                          size="small"
                          onClick={onDownloadBillClick.bind(null, report)}
                          disabled={report?.status === "failed"}
                          sx={{
                            direction: "rtl",
                            margin: "0  4px ",
                            backgroundColor: "#ebebeb",
                            padding: "4px",
                            width: "28px",
                            height: "28px",
                            minWidth: "28px",
                            minHeight: "28px",
                            "& svg": { fontSize: "13.6px" }
                          }}
                        >
                          <DownloadIcon />
                        </IconButton>
                      )}
                      {report.card_type === "Bill" && (
                        <IconButton
                          aria-label="settings"
                          color="info"
                          size="small"
                          onClick={() => {
                            setSelectedReport(report);
                            setImageModal(true);
                          }}
                          disabled={report?.status === "failed"}
                          sx={{
                            direction: "rtl",
                            margin: "0  4px ",
                            backgroundColor: "#ebebeb",
                            padding: "4px",
                            width: "28px",
                            height: "28px",
                            minWidth: "28px",
                            minHeight: "28px",
                            "& svg": { fontSize: "13.6px" }
                          }}
                        >
                          <UploadIcon color="success" />
                        </IconButton>
                      )}
                      <IconButton
                        aria-label="failed"
                        color="error"
                        size="small"
                        onClick={onEditClick.bind(null, report, "failed")}
                        disabled={report?.status === "failed"}
                        sx={{
                          direction: "rtl",
                          margin: "0  4px ",
                          backgroundColor: "#ebebeb",
                          padding: "4px",
                          width: "28px",
                          height: "28px",
                          minWidth: "28px",
                          minHeight: "28px",
                          "& svg": { fontSize: "13.6px" }
                        }}
                      >
                        <CancelIcon />
                      </IconButton>
                      <IconButton
                        aria-label="pending"
                        color="black"
                        size="small"
                        onClick={onEditClick.bind(null, report, "pending")}
                        disabled={
                          report?.status === "pending" ||
                          report?.status === "proccessing"
                        }
                        sx={{
                          direction: "rtl",
                          margin: "0 4px ",
                          backgroundColor: "#ebebeb",
                          padding: "4px",
                          width: "28px",
                          height: "28px",
                          minWidth: "28px",
                          minHeight: "28px",
                          "& svg": { fontSize: "13.6px" }
                        }}
                      >
                        <PendingIcon color="success" />
                      </IconButton>
                      <IconButton
                        aria-label="success"
                        color="success"
                        size="small"
                        onClick={onEditClick.bind(null, report, "success")}
                        disabled={report?.status === "success"}
                        sx={{
                          direction: "rtl",
                          margin: "0 4px",
                          backgroundColor: "#ebebeb",
                          padding: "4px",
                          width: "28px",
                          height: "28px",
                          minWidth: "28px",
                          minHeight: "28px",
                          "& svg": { fontSize: "13.6px" }
                        }}
                      >
                        <CheckCircleIcon />
                      </IconButton>

                      {/* </Box> */}
                    </Box>
                  )}
                </Box>
              </Grid>
              {conditionalReturn(
                showCancelRequist,
                <Grid item container justifyContent="center" md={12} xs={12}>
                  <HourglassEmptyIcon />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      );

      const className = isFailedReport
        ? `${classes.tableDanger}`
        : isSuccessfulReport
          ? "table-green"
          : "table-active";

      return {
        id: new Date().getTime(),
        cells: cells.filter((c) => !!c),
        props: { className },
        collapseRow: {
          component: collapse,
          cellProps: { colspan: 100 },
        },
      };
    });

    const Toggle = ({ id, title, checked, onChange, renderIcon, disabled }) => (
      <Tooltip title={typeof title === 'string' ? title : intl.formatMessage({ id: String(title) })} placement="bottom">
        <Checkbox
          id={id}
          checked={!!checked}
          onChange={(e) => onChange?.(e.target.checked)}
          icon={renderIcon(false)}
          checkedIcon={renderIcon(true)}
          inputProps={{ "aria-label": typeof title === 'string' ? title : intl.formatMessage({ id: String(title) }) }}
          sx={{ p: 0.5 }}
          disabled={!!disabled}
        />
      </Tooltip>
    );

    const hasRows = rows && rows.length > 0;
    const effectiveCount = hasRows ? count : 0;

    return (
      <div className="table-wrapper sales-report-card">
        <HCard style={{ minHeight: "200px", zIndex: 0 }}>
          <HCardHeader
            color="primary"
            icon
            style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px 16px" }}
          >
            <Typography
              color="black"
              sx={{
                display: "inline-block",
                fontSize: "17px",
              }}
            >
              {title}
            </Typography>
            <RefreshButton onClick={onRefresh} sx={{ m: 0 }} />
            <Tooltip title={intl.formatMessage({ id: "Export to Excel" })}>
              <span>
                <ExportButton reports={sellerReports} />
              </span>
            </Tooltip>
            <IconButton
              onClick={toggleFontSize}
              title={`Font Size: ${reportFontSize.charAt(0).toUpperCase() + reportFontSize.slice(1)}`}
              sx={{
                margin: 0,
                padding: "6px",
                minWidth: "32px",
                height: "32px",
                borderRadius: "6px",
                backgroundColor: "#f5f5f5",
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: "#e8e8e8",
                  transform: "translateY(-1px)",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                },
                "&:active": {
                  transform: "translateY(0)",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                },
              }}
            >
              <FormatSizeIcon
                sx={{
                  fontSize: "20px",
                  color: "#FF9800",
                  transition: "all 0.3s ease",
                  transform: reportFontSize === "small" ? "scale(0.85)" : reportFontSize === "large" ? "scale(1.15)" : "scale(1)",
                }}
              />
            </IconButton>
            {onToggleBillerTotals && (
              <Tooltip title={showBillerTotals ? intl.formatMessage({ id: "Hide Biller Totals" }) : intl.formatMessage({ id: "Show Biller Totals" })}>
                <IconButton
                  onClick={() => onToggleBillerTotals(!showBillerTotals)}
                  sx={{
                    margin: 0,
                    padding: "6px",
                    minWidth: "32px",
                    height: "32px",
                    borderRadius: "6px",
                    backgroundColor: showBillerTotals ? "#047857" : "#f5f5f5",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: showBillerTotals ? "#059669" : "#e8e8e8",
                      transform: "translateY(-1px)",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    },
                    "&:active": {
                      transform: "translateY(0)",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <AssessmentIcon
                    sx={{
                      fontSize: "20px",
                      color: showBillerTotals ? "#ffffff" : "#6b7280",
                      transition: "all 0.3s ease",
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}

            {/* Compact filter toggles moved here */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, ml: 1 }}>
              <Toggle
                id="cancel-request"
                title={intl.formatMessage({ id: "cancel request" })}
                checked={cancelRequest}
                onChange={onToggleCancelRequest}
                disabled={false}
                renderIcon={(active) => (
                  <UndoOutlinedIcon color={active ? "primary" : "inherit"} />
                )}
              />
              <Toggle
                id="canceled"
                title={intl.formatMessage({ id: "canceled" })}
                checked={canceled}
                onChange={onToggleCanceled}
                disabled={false}
                renderIcon={(active) => (
                  <CancelOutlinedIcon color={active ? "primary" : "inherit"} />
                )}
              />
              <Toggle
                id="autorenew"
                title={intl.formatMessage({ id: "autorenew" })}
                checked={renew}
                onChange={onToggleRenew}
                disabled={false}
                renderIcon={(active) => (
                  <AutorenewIcon color={active ? "primary" : "inherit"} />
                )}
              />
              {isAdminSeller && (
                <Toggle
                  id="autorun"
                  title={intl.formatMessage({ id: isAdminSearching ? "Stop auto-refresh" : "Auto run" })}
                  checked={autoRun}
                  onChange={onToggleAutoRun}
                  disabled={false}
                  renderIcon={(active) => (
                    isAdminSearching ? (
                      <StopCircleOutlinedIcon color="error" />
                    ) : (
                      <PlayCircleOutlineIcon color={active ? "primary" : "inherit"} />
                    )
                  )}
                />
              )}
            </Box>
            <div style={{ flex: 1 }}></div>

            {/* Statistics Button */}
            <Tooltip title={loadingStatistics ? intl.formatMessage({ id: "Loading..." }) : intl.formatMessage({ id: "View Statistics" })}>
              <IconButton
                onClick={async () => {
                  console.log('📊 Statistics button clicked - loading all data...');
                  setLoadingStatistics(true);
                  try {
                    if (props.onLoadStatisticsData) {
                      await props.onLoadStatisticsData();
                    }
                    setShowStatisticsModal(true);
                  } catch (error) {
                    console.error('Failed to load statistics data:', error);
                  } finally {
                    setLoadingStatistics(false);
                  }
                }}
                disabled={loadingStatistics}
                sx={{
                  margin: "0 8px",
                  padding: "6px",
                  minWidth: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  backgroundColor: loadingStatistics ? "#ccc" : "#f5f5f5",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: loadingStatistics ? "#ccc" : "#e8e8e8",
                    transform: loadingStatistics ? "none" : "translateY(-1px)",
                    boxShadow: loadingStatistics ? "none" : "0 2px 4px rgba(0,0,0,0.1)",
                  },
                  "&:active": {
                    transform: "translateY(0)",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  },
                }}
              >
                {loadingStatistics ? (
                  /* iOS-style spinner */
                  <Box
                    sx={{
                      position: "relative",
                      width: "20px",
                      height: "20px",
                    }}
                  >
                    {[...Array(12)].map((_, index) => (
                      <Box
                        key={index}
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          width: "2px",
                          height: "6px",
                          marginLeft: "-1px",
                          marginTop: "-3px",
                          borderRadius: "1px",
                          backgroundColor: "rgba(37, 99, 235, 0.9)",
                          transformOrigin: "center center",
                          transform: `rotate(${index * 30}deg) translate(0, -7px)`,
                          animation: "ios-fade 1.2s linear infinite",
                          animationDelay: `${-1.2 + index * 0.1}s`,
                          "@keyframes ios-fade": {
                            "0%": { opacity: 1 },
                            "100%": { opacity: 0.2 },
                          },
                        }}
                      />
                    ))}
                  </Box>
                ) : (
                  <BarChartIcon sx={{ fontSize: 20, color: "#2563eb" }} />
                )}
              </IconButton>
            </Tooltip>

            <Sage50ExportButton reportData={sellerReports} filterParams={props.sage50FilterParams} />
            <div style={{ position: "relative", display: "inline-flex", flexDirection: "column", alignItems: "center", marginLeft: "8px" }}>
              <Tooltip title={`${intl.formatMessage({ id: "Rows per Page" })}: ${rowsPerPage}`}>
                <IconButton
                  onClick={() => setShowRowsDropdown(!showRowsDropdown)}
                  sx={{
                    margin: 0,
                    padding: "6px",
                    minWidth: "32px",
                    height: "32px",
                    borderRadius: "6px",
                    backgroundColor: "#f5f5f5",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: "#e8e8e8",
                      transform: "translateY(-1px)",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    },
                    "&:active": {
                      transform: "translateY(0)",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <TableRowsIcon
                    sx={{
                      fontSize: 20,
                      color: "#2563eb",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {showRowsDropdown && (
                <div
                  style={{
                    position: "absolute",
                    top: "40px",
                    right: "0",
                    backgroundColor: isDarkTheme ? "#1f2937" : "#ffffff",
                    color: isDarkTheme ? "#f9fafb" : "#111827",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    border: `1px solid ${isDarkTheme ? "#374151" : "#e5e7eb"}`,
                    zIndex: 1300,
                    minWidth: "150px",
                    padding: "8px",
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                  onMouseLeave={() => setShowRowsDropdown(false)}
                >
                  {[10, 25, 50, 100, 500, 1000, 2000, 3000, 5000].map((rows) => (
                    <div
                      key={rows}
                      onClick={() => {
                        if (onRowsPerPageChange) {
                          onRowsPerPageChange(rows);
                        }
                        setShowRowsDropdown(false);
                      }}
                      style={{
                        fontSize: "14px",
                        fontWeight: rowsPerPage === rows ? "bold" : "normal",
                        backgroundColor: rowsPerPage === rows ? "rgba(4, 120, 87, 0.15)" : "transparent",
                        color: isDarkTheme ? "#f9fafb" : "#111827",
                        borderRadius: "6px",
                        padding: "10px 16px",
                        marginBottom: "4px",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        border: rowsPerPage === rows ? "1px solid #047857" : "1px solid transparent",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = rowsPerPage === rows ? "rgba(4, 120, 87, 0.25)" : isDarkTheme ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = rowsPerPage === rows ? "rgba(4, 120, 87, 0.15)" : "transparent";
                      }}
                    >
                      {rows} {translate("rows")}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* Far right: Reset and Search next to rows-per-page count */}
            <Tooltip title={intl.formatMessage({ id: "Reset Report" })}>
              <IconButton
                onClick={() => onReset?.()}
                sx={{
                  marginLeft: 1,
                  padding: "6px",
                  minWidth: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  backgroundColor: "#f5f5f5",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#e8e8e8",
                    transform: "translateY(-1px)",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  },
                  "&:active": {
                    transform: "translateY(0)",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <RestartAltIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
            <Tooltip title={intl.formatMessage({ id: "Search" })}>
              <IconButton
                onClick={() => onSearch?.()}
                sx={{
                  marginLeft: 1,
                  padding: "6px",
                  minWidth: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  backgroundColor: "#1976d2",
                  color: "#ffffff",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#1565c0",
                    transform: "translateY(-1px)",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  },
                  "&:active": {
                    transform: "translateY(0)",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <SearchIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
            {conditionalReturn(
              hide,
              <VisibilityOffIcon
                style={{
                  margin: 0,
                  color: "black",
                }}
              />
            )}
          </HCardHeader>

          <HTable
            rowOptions={{
              cellProps: {
                padding: "none",
                style: {
                  padding: "3px",
                  fontSize: currentFontSizes.base,
                },
              },
            }}
            collapseOptions={{}}
            emptyViewText={translate("No data to show")}
            tableContainerProps={{
              component: "div",
              sx: {
                fontSize: currentFontSizes.base,
                // Prevent the wide report table from breaking the page on
                // narrow screens. Container scrolls horizontally instead.
                overflowX: "auto",
                WebkitOverflowScrolling: "touch",
                "& *": {
                  fontSize: "inherit",
                },
                "& h6": {
                  fontSize: currentFontSizes.header,
                  fontWeight: 600,
                  padding: "4px 0",
                  margin: 0,
                  lineHeight: 1.2,
                },
                "& .MuiTableRow-head": {
                  height: "auto",
                  "& .MuiTableCell-root": {
                    padding: "6px 4px",
                    height: "auto",
                  },
                },
                "& thead th": {
                  padding: "6px 4px !important",
                },
              },
            }}
            // pagination
            heads={heads}
            rows={rows}
          />
          {hasRows && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography>Page: {page}</Typography>
                <Pagination
                  count={Math.ceil(effectiveCount / rowsPerPage)}
                  page={page}
                  onChange={(_, page) => {
                    onPageChange?.(page);
                  }}
                />
              </Box>
              <TablePagination
                component="div"
                count={effectiveCount}
                page={(page || 1) - 1}
                onPageChange={(_, page) => {
                  onPageChange?.(page + 1);
                }}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => onRowsPerPageChange?.(e.target.value)}
                rowsPerPageOptions={[]}
                labelRowsPerPage=""
              />
            </Box>
          )}
        </HCard>
      </div>
    );
  }

  const renderNoteModal = () => (
    <Modal
      visible={isFieldModalOpened}
      onClose={handleCloseEditField}
      title={`update ${editField.fieldName}`}
      width="400px"
      onSuccess={updateTransactionField}
      onSuccessLoading={isUpdateFieldLoading}
    >
      <div
        style={{
          height: "150px",
          marginTop: "26px",
        }}
      >
        <TextFieldGroup
          type="text"
          label={editField.fieldName}
          value={editField.value}
          onChange={handleNoteChange}
          required={true}
        />
      </div>
    </Modal>
  );

  return (
    <>
      {imageModal && (
        <Modal
          visible={ImageModal}
          onClose={() => setImageModal(false)}
          title="Upload Image"
          width="400px"
          onSuccess={sendImage}
          onSuccessLoading={isUploadImageLoading}
        >
          <UploadImage setImage={setImage} message="Upload Image" />
        </Modal>
      )}

      {openModal && (
        <SelectSeller
          allSeller={get_allsellers}
          amount={amountSeller}
          openModal={openModal}
          setOpenModal={setOpenModal}
          onSettingClick={onSettingClick}
        />
      )}
      {openImageModal && (
        <ImageModal
          openModal={openImageModal}
          setOpenModal={setOpenImageModal}
          number={WhatsAppNote.note}
          transId={WhatsAppNote.transId}
          paltelNumber={WhatsAppNote.number}
        />
      )}
      <ShareModal
        shareModal={openShareModal}
        setShareModal={setOpenShareModal}
        referalCode={referalCode}
        contentMessage={shareContent || null}
      />
      {renderHTable()}
      {renderNoteModal()}
      {(isLoading || onLoadingSetting) && (
        <Box
          sx={{
            display: "flex",
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(-50%,-50%)",
            zIndex: 9999,
          }}
        >
          {/* iOS-style spinner */}
          <Box
            sx={{
              position: "relative",
              width: "50px",
              height: "50px",
            }}
          >
            {[...Array(12)].map((_, index) => (
              <Box
                key={index}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: "3px",
                  height: "12px",
                  marginLeft: "-1.5px",
                  marginTop: "-6px",
                  borderRadius: "1.5px",
                  backgroundColor: "rgba(25, 118, 210, 0.9)",
                  transformOrigin: "center center",
                  transform: `rotate(${index * 30}deg) translate(0, -17px)`,
                  animation: "ios-fade 1.2s linear infinite",
                  animationDelay: `${-1.2 + index * 0.1}s`,
                  "@keyframes ios-fade": {
                    "0%": { opacity: 1 },
                    "100%": { opacity: 0.2 },
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      )}

      {/* Statistics Modal */}
      <StatisticsModal
        open={showStatisticsModal}
        onClose={() => setShowStatisticsModal(false)}
        reportData={sellerReports}
        dateRange={{
          from: props.sage50FilterParams?.dateFrom || new Date(),
          to: props.sage50FilterParams?.dateTo || new Date(),
        }}
      />

      {/* Contact Seller Modal */}
      <ContactSellerModal
        open={contactModalOpen}
        sellerId={contactSeller.sellerId}
        sellerName={contactSeller.sellerName}
        onClose={() => {
          setContactModalOpen(false);
          setContactSeller({ sellerId: "", sellerName: "" });
        }}
      />
    </>
  );
}

SaleReportTable.propTypes = propTypes;
const mapStateToProps = (state) => ({
  auth: state.auth,
  isDarkTheme: state.darkTheme.isDarktheme,
});
export default connect(mapStateToProps, { chargeJawwal, chargeOoredoo })(
  SaleReportTable
);
